export interface AuthState {
  authResp: any;
}

export const initialAuthState: AuthState = {
  authResp: null,
};
